<template>
  <div id="list-item-content" :class="{'list-info': currentStateIndex===2}" @touchstart="handleTouch" @scroll.stop="onTouchScroll" @touchmove="onTouchMove">
    <div class="list-item scroll-area" v-for="(listItem, listIndex) in mapData" :key="listIndex" @click.stop="viewDetails(listItem)">
      <img v-if="listItem.imgUrl" class="right-img" :src="listItem.imgUrl.split('')[0]" alt="" @click.stop="imgPreview(listItem.imgUrl.split('')[0])">
      <img v-else class="right-img" src="@/assets/images/icon_noimg.png" alt="">
      <div class="left-info">
        <div class="title-name txt-ellipsis" :class="{'store-status': listItem.status !==1}">{{ listItem.customerName }}</div>
        <div class="ba-store-type" v-if="pageType === 'storeMaintain'">
          <div class="status-info txt-ellipsis" :class="listItem.customerTag | formatTagClass">{{ listItem.customerTag | formatTag }}</div>
          <div v-if="listItem.dutyName">BA：{{ listItem.dutyName }}</div>
        </div>
        <div class="already-operation" v-if="['storeExpansion'].includes(pageType) && listItem.isAllot === 1">{{ $t('button.alreadyInOperation') }}</div>
        <div class="already-operation" v-if="['storeExpansion'].includes(pageType) && listItem.status && subItem.status !== 1">{{ listItem.status === 1 ? 'Business' : listItem.status === -1 ? 'Temporarily Closed' : listItem.status === -2 ? 'Permanently Closed' : listItem.status === -3 ? 'Invalid' : '' }}</div>
        <div class="last-activity" v-if="((['storeExpansion'].includes(pageType) && listItem.isAllot !== 1) || !['storeExpansion'].includes(pageType)) && (listItem.lastOperationType || listItem.operationUserName || !['', null].includes(listItem.visitDifferDay))">
          <span class="oper-type">{{ listItem.lastOperationType }}</span> <span v-if="listItem.operationUserName">{{ $t('shared.by') }} {{ listItem.operationUserName }}</span> <span v-if="!['', null].includes(listItem.visitDifferDay)"><span class="oper-time">{{ listItem.visitDifferDay | formatTime }}</span> <span v-show="listItem.visitDifferDay > 1">{{ $t('shared.daysAgo') }}</span></span>
        </div>
        <div class="bottom-section" v-if="listItem.isAllot !== 1 && ['storeExpansion', 'Mapping'].includes(pageType)">
          <div v-if="checkPer(['admin', 'app:expandCustomer:update'])" class="mapping-btn" @click.stop="toUrl(listItem, 'mapping')">{{ ['storeExpansion', 'Mapping'].includes(pageType) ? $t('shared.mapping') : pageType }}</div>
          <div v-if="['storeExpansion'].includes(pageType) && checkPer(['admin', 'app:expand:addOrUpdate'])" class="visit-btn" @click.stop="toUrl(listItem, 'visit')">{{ $t('shared.visitSellIn') }}</div>
        </div>
      </div>
    </div>
    <XuVisitDialog ref="xuVisitDialogRef" :currentVisitInfo="currentVisitInfo" :customerId="customerId" />
  </div>
</template>

<script>
import { ImagePreview, Toast } from 'vant'
import { arsVisitLastApi } from '@/api/visit'
import i18n from '@/i18n'
export default {
  components: {
    XuVisitDialog: () => import('@/components/XuVisitDialog')
  },
  props: {
    mapData: {
      type: Array,
      default: () => []
    },
    currentStateIndex: {
      type: [String, Number],
      default: 0
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  filters: {
    formatTime (val) {
      if ([null, ''].includes(val)) {
        return ''
      }
      // return moment().diff(moment(val), 'days') === 0 ? 'today' : moment().diff(moment(val), 'days') === 1 ? 'yesterday' : moment().diff(moment(val), 'days')
      return val === 0 ? i18n.t('shared.today') : val === 1 ? i18n.t('shared.yesterday') : val
    },
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      startY: 0,
      currentVisitInfo: {},
      customerId: ''
    }
  },
  methods: {
    viewDetails (params) {
      this.$emit('clearRequest')
      if (this.pageType === 'storeMaintain') {
        this.$router.push(`/storeMaintain/workItem?customerId=${params.id}`)
      } else {
        this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${params.id}`)
      }
    },
    resetScroll (val) {
      this.$nextTick(() => {
        document.getElementById('list-item-content').scrollTop = 1
      })
    },
    imgPreview (url) {
      ImagePreview([url])
    },
    handleTouch (e) {
      if (this.currentStateIndex === 2) {
        e.stopPropagation()
      }
    },
    onTouchScroll (e) {
      const element = document.getElementById('list-item-content')
      this.$nextTick(() => {
        if (
          e.target.scrollTop === 0 &&
          element.scrollHeight > element.clientHeight
        ) {
          this.$emit('handleHeight')
          e.preventDefault()
        }
      })
    },
    onTouchMove (e) {
      this.$nextTick(() => {
        if (document.getElementById('list-item-content').scrollTop === 0) {
          e.preventDefault()
        }
      })
    },
    toUrl (params, type) {
      if (this.pageType === 'storeExpansion') {
        this.$emit('clearRequest')
        if (type === 'mapping') {
          this.$router.push(`/storeExpansion/storeMapping?customerId=${params.id}`)
          return
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsVisitLastApi(params.id, '1').then(res => {
          Toast.clear()
          this.currentVisitInfo = res.data
          this.customerId = params.id
          if (res.data.lastType === 0) {
            this.$router.push(`/storeExpansion/visitSellIn?customerId=${params.id}`)
          } else {
            this.$refs.xuVisitDialogRef.dialogShow = true
          }
        })
      } else {
        this.$emit('clearRequest')
        this.$router.push(`/storeExpansion/storeMapping?customerId=${params.id}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.list-info {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y; /* 关键：告诉浏览器“我来处理滚动” */
}
.list-item {
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  .left-info {
    flex: 1;
    margin-left: 3px;
  }
  .title-name {
    width: 290px;
    font-size: 15px;
    margin-bottom: 12px;
  }
  .store-status {
    text-decoration: underline;
  }
  .ba-store-type {
    display: flex;
    align-items: center;
    margin: 5px 0;
    .status-info {
      max-width: 76px;
      padding: 3px 5px;
      text-align: center;
      font-size: 10px;
      border: 1px solid #ee541b;
      color: #ee541b;
      background-color: #eccfc4;
      margin-right: 6px;
    }
    .tag0 {
      border: 1px solid #0db00b;
      color: #0db00b;
      background-color: #abdaaa;
    }
    .tag2 {
      border: 1px solid #dc851f;
      color: #dc851f;
      background-color: #f0e2d1;
    }
    .tag3 {
      border: 1px solid #7f7f7f;
      color: #7f7f7f;
      background-color: #dcdcdc;
    }
  }
  .last-activity {
    .oper-type,
    .oper-time {
      color: #307bff;
      font-weight: bold;
    }
  }
  .already-operation {
    color: #c4200b;
    font-size: 12px;
  }
  .bottom-section {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .mapping-btn,
    .visit-btn {
      padding: 5px 10px;
      margin-top: 5px;
      background-color: #fff;
      color: #307bff;
      border-radius: 10px;
    }
    .visit-btn {
      background-color: #307bff;
      color: #fff;
      margin-left: 10px;
    }
    .mapping-btn {
      border: 1px solid #307bff;
    }
  }
  .right-img {
    width: 52px;
    height: 52px;
  }
}
/* 保证浏览器提前识别可滚动方向 */
.scroll-area {
  touch-action: pan-y; /* 关键：告诉浏览器“我自己来” */
}
</style>
